import React from "react";
import FrontHeader from "./FrontHeader";
import FrontFooter from "./FrontFooter";

const FrontLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-brand-body font-sans text-gray-800 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
        {/* Orange Blob 1 */}
        <div className="absolute top-[-10%] left-[-10%] w-72 h-72 bg-brand-orange/10 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        
        {/* Yellow Blob 2 */}
        <div className="absolute top-[20%] right-[-5%] w-96 h-96 bg-yellow-200/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
        
        {/* Orange Blob 3 */}
        <div className="absolute bottom-[20%] left-[20%] w-80 h-80 bg-brand-orange/5 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
      </div>
      <FrontHeader />

      {/* We add a subtle transition for the main content area */}
      <main className="flex-grow">{children}</main>

      <FrontFooter />
    </div>
  );
};

export default FrontLayout;
